import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';

interface TemplateManagerProps {
  launchId: string;
}

export function TemplateManager({ launchId }: TemplateManagerProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <AlertCircle className="h-5 w-5 text-yellow-500" />
          Gestión de Plantillas
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">
          La gestión de plantillas múltiples no está disponible en esta versión.
          Cada lanzamiento usa una sola plantilla de reporte.
        </p>
      </CardContent>
    </Card>
  );
}